import { z } from 'zod';
// --- Not şemaları ---
export const noteCreateSchema = z.object({
    title: z.string().min(1, 'Başlık zorunludur').max(500),
    content: z.string().optional().default(''),
    contentType: z.enum(['plain', 'markdown', 'html']).optional().default('plain'),
    color: z
        .string()
        .regex(/^#[0-9A-Fa-f]{6}$/, 'Geçerli bir HEX renk kodu giriniz')
        .optional()
        .nullable(),
    contextType: z.string().max(50).optional(),
    contextId: z.coerce.number().int().positive().optional(),
    tagIds: z.array(z.coerce.number().int().positive()).optional(),
});
export const noteUpdateSchema = z.object({
    title: z.string().min(1, 'Başlık zorunludur').max(500).optional(),
    content: z.string().optional(),
    contentType: z.enum(['plain', 'markdown', 'html']).optional(),
    color: z
        .string()
        .regex(/^#[0-9A-Fa-f]{6}$/, 'Geçerli bir HEX renk kodu giriniz')
        .optional()
        .nullable(),
});
export const noteListQuerySchema = z.object({
    page: z.coerce.number().int().positive().optional().default(1),
    perPage: z.coerce.number().int().min(1).max(100).optional().default(20),
    search: z.string().optional(),
    tags: z.string().optional(), // virgülle ayrılmış tag ID'leri: "1,2,3"
    filter: z.enum(['all', 'pinned', 'archived', 'trash', 'shared']).optional().default('all'),
    contextType: z.string().optional(),
    contextId: z.coerce.number().int().positive().optional(),
    sortBy: z.enum(['created_at', 'updated_at', 'title']).optional().default('updated_at'),
    sortOrder: z.enum(['asc', 'desc']).optional().default('desc'),
});
// --- Paylaşım şemaları ---
export const noteShareSchema = z.object({
    sharedWithType: z.enum(['user', 'group']),
    sharedWithId: z.coerce.number().int().positive('Geçerli bir ID giriniz'),
    role: z.enum(['viewer', 'editor']).optional().default('viewer'),
});
export const noteShareUpdateSchema = z.object({
    role: z.enum(['viewer', 'editor']),
});
// --- Etiket şemaları ---
export const tagCreateSchema = z.object({
    name: z.string().min(1, 'Etiket adı zorunludur').max(50),
    slug: z
        .string()
        .max(50)
        .regex(/^[a-z0-9]+(?:-[a-z0-9]+)*$/, 'Slug sadece küçük harf, rakam ve tire içerebilir')
        .optional(),
    color: z
        .string()
        .regex(/^#[0-9A-Fa-f]{6}$/, 'Geçerli bir HEX renk kodu giriniz')
        .optional()
        .nullable(),
});
export const tagUpdateSchema = z.object({
    name: z.string().min(1, 'Etiket adı zorunludur').max(50).optional(),
    slug: z
        .string()
        .max(50)
        .regex(/^[a-z0-9]+(?:-[a-z0-9]+)*$/, 'Slug sadece küçük harf, rakam ve tire içerebilir')
        .optional(),
    color: z
        .string()
        .regex(/^#[0-9A-Fa-f]{6}$/, 'Geçerli bir HEX renk kodu giriniz')
        .optional()
        .nullable(),
});
export const noteTagsUpdateSchema = z.object({
    tagIds: z.array(z.coerce.number().int().positive()).min(0),
});
// --- Checklist şemaları ---
export const checklistCreateSchema = z.object({
    content: z.string().min(1, 'Görev metni zorunludur').max(500),
    sortOrder: z.coerce.number().int().min(0).optional().default(0),
});
export const checklistUpdateSchema = z.object({
    content: z.string().min(1, 'Görev metni zorunludur').max(500).optional(),
    sortOrder: z.coerce.number().int().min(0).optional(),
});
export const checklistReorderSchema = z.object({
    items: z
        .array(z.object({
        id: z.coerce.number().int().positive(),
        sortOrder: z.coerce.number().int().min(0),
    }))
        .min(1, 'En az bir öğe gereklidir'),
});
// --- Ortak param şemaları ---
export const noteIdParamSchema = z.object({
    id: z.coerce.number().int().positive('Geçerli bir not ID giriniz'),
});
export const shareIdParamSchema = z.object({
    id: z.coerce.number().int().positive(),
    shareId: z.coerce.number().int().positive(),
});
export const attachmentIdParamSchema = z.object({
    attachmentId: z.coerce.number().int().positive(),
});
export const revisionIdParamSchema = z.object({
    id: z.coerce.number().int().positive(),
    revisionId: z.coerce.number().int().positive(),
});
export const checklistItemParamSchema = z.object({
    id: z.coerce.number().int().positive(),
    itemId: z.coerce.number().int().positive(),
});
//# sourceMappingURL=note.schema.js.map